var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("SURGERY")]),_c('h4',[_vm._v("The branch of medicine dealing with manual or operative procedures for the correction of deformities and defects, repair of injuries, diagnosis and cure of certain diseases. This includes surgery performed in an out-patient setting for a covered Illness or Injury.")])])
}]

export { render, staticRenderFns }